import { useEffect } from 'react';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import iconFontUrl from 'react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf';
import { App } from '../src';

// Generate required css

const iconFontStyles = `@font-face {
  font-family: 'MaterialCommunityIcons';
  src: url('${iconFontUrl}') format('truetype');
}`;

const WebApp = () => {
  useEffect(() => {
    // Inject stylesheet
    const element = document.createElement('style') as HTMLStyleElement;
    if (element.sheet) {
      element.sheet.cssRules[0].cssText = iconFontStyles;
    } else {
      element.appendChild(document.createTextNode(iconFontStyles));
    }
    document.head.appendChild(element);

    return () => {
      document.head.removeChild(element);
    };
  }, []);

  return (
    <GestureHandlerRootView style={{ flex: 1 }}>
      <App />
    </GestureHandlerRootView>
  );
};

export default WebApp;
